import { css, html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';

import { iconGear } from '@/components/icons';
import { BREAKPOINT_MEDIUM_PX } from '@/settings';
import { baseStyles, printProofStyles } from '@/styles';
import { t } from 'i18next';

@customElement('fg-configuration-print-processing')
export class FgConfigurationPrintProcessing extends LitElement {
  render() {
    return html`
      <div class="status processing">
        <p class="message">
          ${iconGear}
          <span>${t('content.printProof.statusProcessing')}</span>
        </p>
      </div>
    `;
  }

  static styles = [
    baseStyles,
    printProofStyles,
    css`
      .status {
        gap: 8px;
        justify-content: flex-start;
        align-items: center;
      }

      :host([part='wholesale']) .status {
        border: 1px solid var(--fg-gray--300, var(--fg-fallback-gray--300));
      }

      .status.processing {
        background-color: var(--fg-gray--100, var(--fg-fallback-gray--100));
      }

      @media screen and (min-width: ${BREAKPOINT_MEDIUM_PX}px) {
        :host([part='retail']) .status {
          padding: 17px 24px;
        }

        :host([part='wholesale']) .status {
          padding: 14px 16px;
        }
      }
    `,
  ];
}
